export default __webpack_public_path__ + "static/media/wizard_black.5c90220e.svg";